import React from "react";
import "../../css/Button.css";

const Button = ({
  text,
  variant = "primary",
  onClick,
  className = "",
  type = "button",
  ...props
}) => {
  return (
    <button
      type={type}
      className={`pf-button pf-button-${variant} ${className}`}
      onClick={onClick}
      {...props}
      >
          <div className="content-semibold">
            {text}
          </div>
    </button>
  );
};

export default Button;
